import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchAgencyTitleDetail, } from "../api/enforcementService";
export var useAgencyTitleDetail = function (productNumber, enabled) {
    var kyInstance = useOkapiKy();
    return useQuery(["agency-title-detail", productNumber], function () { return fetchAgencyTitleDetail(kyInstance, productNumber !== null && productNumber !== void 0 ? productNumber : ""); }, {
        enabled: enabled && Boolean(productNumber),
        cacheTime: 60000,
        staleTime: Infinity,
    });
};
